import emptyUsers from "assets/images/users/emptyUsers.png";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Table from "examples/Tables/Table";
import ActivateDeactivateUser from "layouts/users/components/ActivateDeactivateuser";
import React, { useState } from "react";
import { FadeLoader } from "react-spinners";
import { toast } from "react-toastify";
import Formatmessage from "services/Formatmessage";
import useLogout from "services/Handlelogout";
import UsersRow, { columns } from "store/action/User";
import { useGetuserslistQuery } from "store/api/users.api";
import useStore from "store/hook";
import univerSityImage from "assets/images/dashboard/university.png";
import usersImage from "assets/images/dashboard/users.png";
import reportedUserImage from "assets/images/dashboard/reportedUsers.png";
import cityImage from "assets/images/dashboard/cities.png";
import Dashboardcard from "./components/Dashboardcard";
import { Link } from "react-router-dom";
import { useGetdashboarddataQuery } from "store/api/users.api";

function Dashboard() {
  const [usersData, setUsersData] = useState([]);
  const [page, setPage] = useState(1);
  const [tolatPages, setTotalpages] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const [regex, setRegex] = React.useState("");
  const [newRegex, setNewRegex] = React.useState("");
  const [selectedUniversitiesIdsData, setSelectedUniversitiesIdsData] = useState([]);
  const [dashboardTopData, setDashboardTopData] = useState();

  const logout = useLogout();

  const debouncedSetRegex = React.useCallback(
    debounce((value) => {
      setPage(1);
      setNewRegex(value);
    }, 1000),
    []
  );

  React.useEffect(() => {
    debouncedSetRegex(regex);
  }, [regex, debouncedSetRegex]);

  const { data, isLoading, isFetching, error, refetch } = useGetuserslistQuery({
    page: page,
    limit: 20,
    type: newRegex ? "search" : "list",
    searchText: newRegex,
    uni_filter: selectedUniversitiesIdsData,
    status: "active",
  });

  const {
    data: dashboardData,
    isLoading: dashboardLoadding,
    isFetching: dashboardFetching,
    error: dashboardError,
  } = useGetdashboarddataQuery();

  const { store, setDialogue } = useStore();

  React.useEffect(() => {
    if (data?.status === 1) {
      setUsersData(data?.data?.users);
      setTotalpages(data?.data?.totalPages);
      setTotalUsers(data?.data?.totalUsers);
    } else if (data?.status == 0) {
      toast.error(Formatmessage(data?.message));
    } else if (data?.status == 10) {
      logout();
    }
  }, [data]);

  React.useEffect(() => {
    if (dashboardData?.status === 1) {
      setDashboardTopData(dashboardData?.data);
    } else if (dashboardData?.status == 0) {
      toast.error(Formatmessage(data?.message));
    } else if (dashboardData?.status == 10) {
      logout();
    }
  }, [dashboardData]);

  const rows = React.useMemo(
    () => (usersData ? usersData?.map((user) => UsersRow(user, setDialogue)) : []),
    [usersData]
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <SoftBox
        sx={{
          pr: { xs: 1, sm: 2, md: 4 },
          pl: { xs: 1, sm: 2, md: 2 },
          top: { xs: "55%", sm: "40%" },
        }}
        position="absolute"
        width="100%"
      >
        {isLoading || dashboardLoadding || isFetching ? (
          <SoftBox
            sx={{
              height: "calc(60vh)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <FadeLoader color="#3DC2EB" />
          </SoftBox>
        ) : (
          <SoftBox display="flex" flexDirection="column" gap={3} pb={2}>
            <SoftBox
              display="flex"
              sx={{ flexDirection: { xs: "column", sm: "column", md: "row" } }}
              gap={3}
            >
              <Dashboardcard
                image={usersImage}
                title="Users"
                count={dashboardTopData?.totalUsers}
              />
              <Dashboardcard
                image={univerSityImage}
                title="Schools"
                count={dashboardTopData?.totalSchools}
              />
              <Dashboardcard
                image={cityImage}
                title="Cities"
                count={dashboardTopData?.totalCities}
              />
              <Dashboardcard
                image={reportedUserImage}
                title="Reported users"
                count={dashboardTopData?.totalReportedUsers}
              />
            </SoftBox>

            <SoftBox
              border="1px solid #D8E0E8"
              width="100%"
              borderRadius="md"
              sx={{ backgroundColor: "white.main" }}
            >
              <SoftBox
                sx={{ p: 2 }}
                display="flex"
                flexWrap="wrap"
                alignItems="center"
                justifyContent="space-between"
                gap={2}
              >
                <SoftBox
                  display="flex"
                  sx={{ alignItems: "center", justifyContent: "start", gap: 2 }}
                >
                  <SoftTypography sx={{ fontSize: 16, fontWeight: "medium", color: "black.main" }}>
                    Users
                  </SoftTypography>

                  <SoftBox
                    borderRadius="xl"
                    sx={{ backgroundColor: "skyblue.main", px: 2, py: 0.1 }}
                  >
                    <SoftTypography
                      sx={{ fontSize: 16, fontWeight: "medium", color: "primary.main" }}
                    >
                      {totalUsers}
                    </SoftTypography>
                  </SoftBox>
                </SoftBox>

                <SoftBox
                  display="flex"
                  flexWrap="wrap"
                  sx={{ alignItems: "center", justifyContent: "start", gap: 2 }}
                >
                  <SoftButton
                    component={Link}
                    to="/users"
                    color="primary"
                    variant="contained"
                    sx={{
                      fontSize: 14,
                      textTransform: "capitalize",
                      gap: 2,
                    }}
                  >
                    view All
                  </SoftButton>
                </SoftBox>
              </SoftBox>

              <SoftBox
                sx={{ p: 2 }}
                width="100%"
                display="flex"
                gap={1}
                alignItems="center"
                justifyContent="start"
                flexWrap="wrap"
              ></SoftBox>

              <SoftBox>
                {usersData?.length > 0 ? (
                  <SoftBox
                    sx={{
                      "& .MuiTableRow-root:not(:last-child)": {
                        "& td": {
                          borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                            `${borderWidth[1]} solid ${borderColor}`,
                        },
                      },
                    }}
                  >
                    <Table columns={columns} rows={rows} />
                  </SoftBox>
                ) : (
                  <SoftBox
                    sx={{
                      height: "calc(70vh)",
                      overflowY: "auto",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "start",
                      alignItems: "center",
                      gap: 2,
                    }}
                  >
                    <SoftBox
                      display="flex"
                      flexDirection="column"
                      gap={8}
                      justifyContent="center"
                      alignItems="center"
                      width="100%"
                    >
                      <SoftBox
                        display="flex"
                        justifyContent="space-between"
                        width="100%"
                        sx={{
                          backgroundColor: "skyblue.main",
                        }}
                      >
                        {columns.map(({ name, align, width }, index) => (
                          <SoftBox
                            key={index}
                            width={width}
                            align={align}
                            fontWeight="medium"
                            fontSize="14px"
                            py="10px"
                            px="24px"
                            color="black"
                            sx={{ fontWeight: 500, textTransform: "capitalize" }}
                          >
                            {name}
                          </SoftBox>
                        ))}
                      </SoftBox>

                      <SoftBox display="flex" flexDirection="column" alignItems="center">
                        <SoftBox
                          height="200px"
                          width="200px"
                          borderRadius="lg"
                          sx={{
                            backgroundImage: `url(${emptyUsers})`,
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            backgroundSize: "contain",
                          }}
                        />

                        <SoftTypography fontWeight="bold" color="black" sx={{ fontSize: 20 }}>
                          No Users Available
                        </SoftTypography>
                        <SoftTypography fontWeight="medium" color="gray" sx={{ fontSize: 12 }}>
                          We couldn’t find any users for your search. Please refine your keywords or
                          once users sign up, they will appear here.
                        </SoftTypography>
                      </SoftBox>
                    </SoftBox>
                  </SoftBox>
                )}
              </SoftBox>
            </SoftBox>
          </SoftBox>
        )}
      </SoftBox>
      <ActivateDeactivateUser />
    </DashboardLayout>
  );
}

// Debounce function
function debounce(func, delay) {
  let timeoutId;
  return function (...args) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

export default Dashboard;
